import React, { useState, useCallback } from 'react';
import styled, { css, keyframes } from 'styled-components';
import produce from 'immer';
import ReactGA from 'react-ga';

import SearchList from './itemList/SearchList';
import ImageList from './itemList/ImageList';
import IconArrow from '../../../assets/icon/3-10@2x.png';
import { NetworkData, Result, Payload } from '../../../lib/tabAI/type';
import { tabAIState } from '../../../modules/tabAI';
import { PayloadResult } from '../../../lib/tabAI/recommendType';
import { media } from '../../common/Layout';
import {
  MoreViewBoxResult,
  MoreViewInnerBoxResult,
  MoreViewArrowResult,
  MoreViewTitleResult,
} from '../common/Layout';
import { PostConsumptionBodyType } from '../../../lib/common/type';

type StyledType = {
  isTabOpen: boolean;
};

const PathContentComponent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 14px;
  width: 100%;

  /* Mobile Device */
  margin-bottom: 56px;

  ${media.desktop`
    margin-bottom: 60px;
  `};
`;

const PathContentNav = styled.div`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: space-between;

  /* Mobile Device */
  margin-bottom: 8px;

  ${media.desktop`
    margin-bottom: 16px;
  `};
`;
const PathContentTitleBox = styled.div`
  display: flex;
  /* flex: 1 0 auto; */
  height: 24px;
`;
const PathContentTitleBold = styled.div`
  font-family: 'NotoKrM';
  font-weight: 500;
  font-size: 16px;
  height: 24px;
`;
const PathContentTitleLight = styled.div`
  margin-left: 2px;
  font-family: 'NotoKrR';
  font-weight: normal;
  font-size: 16px;
  height: 24px;
`;
const PathContentTabBox = styled.div`
  display: flex;
`;
const PathContentTab = styled.div`
  height: 20px;
  font-family: 'NotoKrM';
  font-size: 14px;

  margin-right: 6px;
  color: #666666;
  cursor: pointer;
  & + & + & {
    margin-right: 0px;
  }
  ${(props: StyledType) => {
    if (props.isTabOpen) {
      return css`
        color: black;
        border-bottom: 1px solid black;
      `;
    }
    return css``;
  }}
`;

interface PathContentProps {
  onSetIsMoreInfoPath0: (
    isMoreInfoPath0: tabAIState['isMoreInfoPath0']
  ) => void;
  onSetIsMoreInfoPath1: (
    isMoreInfoPath1: tabAIState['isMoreInfoPath1']
  ) => void;
  onSetIsMoreInfoPath2: (
    isMoreInfoPath2: tabAIState['isMoreInfoPath2']
  ) => void;

  onSetIsMoreInfoPathAttach0: (
    isMoreInfoPathAttach0: tabAIState['isMoreInfoPathAttach0']
  ) => void;
  onSetIsMoreInfoPathAttach1: (
    isMoreInfoPathAttach1: tabAIState['isMoreInfoPathAttach1']
  ) => void;
  onSetIsMoreInfoPathAttach2: (
    isMoreInfoPathAttach2: tabAIState['isMoreInfoPathAttach2']
  ) => void;

  onPostConsumption: (info: PostConsumptionBodyType) => void;
  pathData: Payload['recommend_path'];
  countData: Payload['total_counts'];
  // recommendData: Result[];
  recommendData: PayloadResult;
  indexPath: number;
  // FakeRecommend_pathData: {
  //   recommend_path: string[];
  // };
}

const PathContent = ({
  pathData,
  countData,
  recommendData,
  indexPath,
  onSetIsMoreInfoPath0,
  onSetIsMoreInfoPath1,
  onSetIsMoreInfoPath2,
  onSetIsMoreInfoPathAttach0,
  onSetIsMoreInfoPathAttach1,
  onSetIsMoreInfoPathAttach2,
  onPostConsumption,
}: PathContentProps) => {
  const [category, setCategory] = useState([
    { id: 0, text: '콘텐츠', active: true },
    { id: 1, text: '이미지', active: false },
    { id: 2, text: '첨부파일', active: false },
  ]);

  const [activeMenu, setActiveMenu] = useState('콘텐츠');

  const onClickTab = useCallback((selectedNumber: number) => {
    setActiveMenu(category[selectedNumber].text);
    setCategory(
      produce((draft) => {
        draft[selectedNumber].active = true;
      })
    );

    category.forEach((element, index) => {
      if (index !== selectedNumber) {
        setCategory(
          produce((draft) => {
            draft[index].active = false;
          })
        );
      }
    });
  }, []);

  const onClickMoreInfo = () => {
    switch (indexPath) {
      case 0:
        onSetIsMoreInfoPath0(true);
        break;
      case 1:
        onSetIsMoreInfoPath1(true);
        break;
      case 2:
        onSetIsMoreInfoPath2(true);
        break;

      default:
        break;
    }
  };
  const onClickMoreInfoAttach = () => {
    switch (indexPath) {
      case 0:
        onSetIsMoreInfoPathAttach0(true);
        break;
      case 1:
        onSetIsMoreInfoPathAttach1(true);
        break;
      case 2:
        onSetIsMoreInfoPathAttach2(true);
        break;

      default:
        break;
    }
  };

  return (
    <PathContentComponent className="PathContentComponent">
      <PathContentNav>
        <PathContentTitleBox>
          <PathContentTitleBold>
            &apos;{pathData[indexPath]}&apos;
          </PathContentTitleBold>
          <PathContentTitleLight>
            검색결과 {countData[indexPath]}개
          </PathContentTitleLight>
        </PathContentTitleBox>
        {/* <PathContentTabBox>
          <PathContentTab
            onClick={() => {
              onClickTab(0);
            }}
            isTabOpen={category[0].active}
          >
            콘텐츠
          </PathContentTab>
          <PathContentTab
            onClick={() => {
              onClickTab(1);
            }}
            isTabOpen={category[1].active}
          >
            이미지
          </PathContentTab>
          <PathContentTab
            onClick={() => {
              onClickTab(2);
            }}
            isTabOpen={category[2].active}
          >
            첨부파일
          </PathContentTab>
        </PathContentTabBox> */}
      </PathContentNav>
      {recommendData ? (
        <>
          <SearchList
            limitList={4}
            recommendData={recommendData}
            onPostConsumption={onPostConsumption}
          />
          <MoreViewBoxResult>
            <MoreViewInnerBoxResult
              onClick={() => {
                ReactGA.ga(
                  'send',
                  'event',
                  `click_search_ai_normal_view_more_button`
                );
                onClickMoreInfo();
                window.scrollTo(0, 0);
              }}
            >
              <MoreViewArrowResult src={IconArrow} alt="more view" />
              <MoreViewTitleResult>추천 콘텐츠 더보기</MoreViewTitleResult>
            </MoreViewInnerBoxResult>
          </MoreViewBoxResult>
        </>
      ) : null}

      {recommendData.recommended_info_image ||
      recommendData.travel_info_image ? (
        <>
          <ImageList
            recommendData={recommendData}
            onPostConsumption={onPostConsumption}
          />
        </>
      ) : null}
    </PathContentComponent>
  );
};

export default PathContent;
